import React, {useState, useEffect} from 'react'

const Cards = (props) => {
  return (
    <ul>
      {
        props.veterinarians.map(veterinarian => {
          return (
            <li>
              <a href={"/veterinarians/" + veterinarian.id}>
                <img className="pic_pro_dr"
                     src={veterinarian.thumbnail_url}/>
                <p className="txt_dr_name">{veterinarian.name}<span>醫師</span></p>
              </a> <span className="icon_pro_address">{veterinarian.hospital_name}</span>
              <div className="department_group">
                {
                  veterinarian.top_skills.map((skill_name) => (
                    <div>{skill_name}</div>
                  ))
                }
              </div>
            </li>
          )
        })
      }
    </ul>
  )
}

export default Cards
